import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserRole_Create, UserRole_Delete, UserRole_ReadAll, UserRole_ReadByUserId, UserRole_Update } from "src/app/GlobalVariable";
import { UserRoleCreateRequestDTO, UserRoleDeleteRequestDTO, UserRoleReadByUserIdRequestDTO, UserRolesDTO, UserRolesList, UserRoleUpdateRequestDTO } from "./userRole.interface";


@Injectable ({
    providedIn: 'root'
})

export class UserRoleService {
    private http= inject(HttpClient);

    UserRoleService_Create(data: UserRoleCreateRequestDTO): Observable<UserRolesDTO> {
        return this.http.post<UserRolesDTO>(UserRole_Create, data);
    }

    UserRoleService_Update(data: UserRoleUpdateRequestDTO): Observable<UserRolesDTO> {
        return this.http.post<UserRolesDTO>(UserRole_Update, data);
    }

    UserRoleService_Delete(data: UserRoleDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(UserRole_Delete, data);
    }

    UserRoleService_ReadAll(): Observable<UserRolesList> {
        return this.http.get<UserRolesList>(UserRole_ReadAll);
    }

    UserRoleService_ReadByUserId(data: UserRoleReadByUserIdRequestDTO): Observable<UserRolesList> {
        return this.http.post<UserRolesList>(UserRole_ReadByUserId, data);
    }
}